/**
 * KB-3270 — the apex (`kidsbooked.com`) session-cookie endpoint URL, in its own
 * leaf module with NO behaviour and NO other imports.
 *
 * ## Why this const lives alone
 *
 * The apex session is a single REST resource with two verbs: `apexSessionMint.ts`
 * POSTs to it (KB-3235, mint the `__session` cookie on sign-in) and
 * `apexSessionRevoke.ts` DELETEs it (KB-3270, clear the cookie on sign-out). Both
 * must target the SAME URL or they silently drift apart, so the URL has to have a
 * single home. The obvious home was `apexSessionMint.ts` — and revoke re-read it
 * from there — but that coupled the two behaviour modules at MODULE SCOPE: any
 * test that `vi.mock`s `apexSessionMint` (several sign-in / door suites do, from
 * KB-3235) and then renders `AuthProvider` pulled revoke's top-level
 * `= APEX_SESSION_MINT_URL` read through the partial mock, which returns no such
 * export, and the whole suite died at COLLECTION before a single test ran
 * (Root Tests red at `5980d48b`; dispatcher ruling on KB-3270).
 *
 * Extracting the URL here removes that coupling: the behaviour modules
 * (`apexSessionMint`, `apexSessionRevoke`, and any future sibling — KB-3271 is
 * queued) each import the URL from this leaf, which nobody mocks. Mocking a
 * behaviour module now says nothing about the URL, because the URL no longer
 * lives in a mocked module. The single-source-of-truth (anti-drift) property is
 * fully preserved — one const, one home — and it is no longer reachable through a
 * mock. Keep this module dependency-free so it stays safe to import at module
 * scope from anywhere.
 */
export const APEX_SESSION_ENDPOINT_URL = "https://kidsbooked.com/api/auth/session";
